module.exports = __webpack_public_path__ + "img/dream_invite_gift.fb19cc4b.png";